import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, DialogContentText } from '@material-ui/core';
import AcertoCoparticipacaoService from '../../services/AcertoCoparticipacaoService';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: theme.spacing.unit * 2,
    fontSize: 12
  },
  typography: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    fontSize: 16,
    textAlign: 'center'
  }
});
class FormDialogProcedimentosPagAntecipado extends React.Component {
  acertosService = new AcertoCoparticipacaoService();
  state = {
    procedimentos: [],
    fetching: false,
    valAcerto: 0,
  }
  componentDidMount = async () => {
    await this.consultarProcedimentos();
  }
  consultarProcedimentos = async () => {
    this.setState({fetching: true});
    let seqProcedimentosSelecionados = [];
    for (var i = 0; i < this.props.procsSelecionados.length; i++) {
      seqProcedimentosSelecionados.push(this.props.procsSelecionados[i][0]);
    }
    let procedimentos = await this.acertosService.consultarProcedimentosPagAntecipado(this.props.numMatricula, seqProcedimentosSelecionados);
    this.setState({procedimentos: procedimentos, fetching: false});
  }

  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    let procedimentosSelecionados = [];
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      procedimentosSelecionados.push(this.state.procedimentos[this.state.rowsSelected[i]]);
    }
    this.props.handleSave(procedimentosSelecionados, this.state.valAcerto);
  }
  render () {
    const options = {
      print: true,
      download: true,
      selectableRows: true,
      rowsSelected: this.state.rowsSelected,
      valAcerto: this.state.valAcerto,
      onRowsSelect: (rowsSelected, allRows) => {
        const selected = allRows.map(item => item.index);
        let valAcertoAux = 0;
        for (var i = 0; i < allRows.length; i++) {
          valAcertoAux = valAcertoAux + this.state.procedimentos[allRows[i].index][14];
        }
        this.setState({rowsSelected: selected, valAcerto: valAcertoAux});
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>procedimento(s) selecionado(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'Cod. Cobrança',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Carteira',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Tabela',
        // options: {
        //   filter: true,
        //   sort: true,
        // }
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Guia',
        // options: {
        //   filter: true,
        //   sort: true,
        // }
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Data do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Valor do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor da Coparticipação',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Resta Pagar',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'seqDivida',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'acoes',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const { open, titulo, nome, numMatricula, classes } = this.props;
    const { procedimentos, fetching } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='lg'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle>{titulo + ' - '}
            Valor Total: {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valAcerto)}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Lista de Procedimentos não Pagos do servidor {numMatricula}  {nome} - {procedimentos !== undefined ? procedimentos.length : 0} registro(s)
            </DialogContentText>
            {fetching ? <LinearProgressBlockScreen />
              : <Paper>
                {procedimentos.length !== 0
                  ? <MUIDataTable
                    data={procedimentos}
                    columns={columns}
                    options={options}
                  />
                  : <Typography className={classes.typography}>Este servidor não possui despesas para pagar antecipadamente</Typography>}
              </Paper>}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={procedimentos.length === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogProcedimentosPagAntecipado);
